import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

const EligiblesTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    {
      key: 'index',
      content: '',
    },

    {
      key: 'name',
      content: t('Name'),
    },

    {
      key: 'totalUnits',
      content: t('TotalVestShareUnits'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'canSell',
      content: t('CanSell'),
      textPosition: 'right',
    },

    {
      key: 'ndPercentage',
      content: '%ND',
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'fdPercentage',
      content: '%FD',
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'offerAmount',
      content: t('OfferAmount'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'unitsSold',
      content: t('SharesUnitsSold'),
      textPosition: 'right',
    },

    {
      key: 'soldAmount',
      content: t('SoldAmount'),
      textPosition: 'right',
    },

    {
      key: 'stickeAmount',
      content: t('StrikePrice'),
      textPosition: 'right',
    },

    {
      key: 'retentionPercentage',
      content: t('RetentionPercentage'),
      textPosition: 'right',
    },

    {
      key: 'netAmount',
      content: t('NetAmount'),
      textPosition: 'right',
    },

    {
      key: 'saleDate',
      content: t('SaleDate'),
      textPosition: 'center',
    },

    {
      key: 'status',
      content: t('Status'),
      textPosition: 'center',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default EligiblesTableHeader;
